export default "__VITE_ASSET__CGARgN3v__"